package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName

enum class CarColor(override val nameAr: String, override val nameFr: String, dtoName: String? = null, val code: String) : EnumDtoName {
    White("أبيض", "Blanc", code = "#F0F0F0"),
    Black("أسود", "Noir", code = "#1A1A1A"),
    Silver("فضي", "Argenté", code = "#C0C0C0"),
    Gray("رمادي", "Gris", code = "#808080"),
    Red("أحمر", "Rouge", code = "#CC0000"),
    Blue("أزرق", "Bleu", code = "#1B4F9E"),
    Green("أخضر", "Vert", code = "#2D6A2D"),
    Yellow("أصفر", "Jaune", code = "#F5C400"),
    Orange("برتقالي", "Orange", code = "#E55B00"),
    Brown("بني", "Marron", code = "#6B3A2A"),
    Beige("بيج", "Beige", code = "#D4C5A9"),
    Gold("ذهبي", "Or", code = "#C5A028"),
    Burgundy("عنابي", "Bordeaux", code = "#6E1020"),
    Navy("كحلي", "Bleu marine", code = "#0A1F44"),
    ;

    override val dtoName = dtoName ?: this.name
}